module.exports = __webpack_public_path__ + "static/media/sample.501e1324.jpg";